import _ from 'lodash';

import environment from '../../../environment';
import { notifyError } from '../../../shared';
import fetch from '../../fetch';
import { stringifyGeoJSON } from '../../utils';
import reducers from './reducers';
import { fetchBlob } from '../../fetchBlob';
import moment from 'moment';

const summary = (() => {
    const get = {
        export (req) {
            req.startDate = environment.validate.date.start(req.startDate, 'YYYYMM');
            req.endDate = environment.validate.date.end(req.endDate, 'YYYYMM');

            if (!_.isArray(req.id)) { req.id = [req.id]; }

            const areaType = req.label ? req.label.split(' ').join('_') : 'Area';

            return fetchBlob({
                fileName: `Summary_${req.name}_v${moment().format('YYYYMMDD')}.xlsx`,
                url: `${environment.get('API_HOST')}/marketsummary/getmidsummaryexport`,
                type: 'GET',
                parameters: {
                    ids: req.id,
                    anoMesInicio: req.startDate,
                    anoMesFim: req.endDate,
                    idTipo: req.type,
                    areaType: req.label,
                    location: req.name,
                },
              });
        },

        locations (req) {
            req.startDate = environment.validate.date.start(req.startDate, 'YYYYMM');
            req.endDate = environment.validate.date.end(req.endDate, 'YYYYMM');

            if (!_.isArray(req.id)) { req.id = [req.id]; }

            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/marketsummary/getmidsummary`,
                header: {
                    'X-UIKey': 'area-selection-summary-view'
                },
                data: {
                    ids: req.id,
                    anoMesInicio: req.startDate,
                    anoMesFim: req.endDate,
                    idTipo: req.type
                },
                error: notifyError
            }).then(res => reducers.location(res, req));
        },

        blocks (req) {
            req.startDate = environment.validate.date.start(req.startDate, 'YYYYMM');
            req.endDate = environment.validate.date.end(req.endDate, 'YYYYMM');

            if (!_.isArray(req.id)) { req.id = [req.id]; }

            return fetch({
                type: 'POST',
                url: `${environment.get('API_HOST')}/marketsummary/Quadrantes`,
                header: {
                    'X-UIKey': 'area-selection-summary-view'
                },
                data: JSON.stringify({
                    quadrantes: req.id,
                    anoMesInicio: req.startDate,
                    anoMesFim: req.endDate
                })
            }).then(res => reducers.location(res, req), notifyError);
        },

        area (req) {
            req.startDate = environment.validate.date.start(req.startDate, 'YYYYMM');
            req.endDate = environment.validate.date.end(req.endDate, 'YYYYMM');

            return fetch({
                type: 'POST',
                url: `${environment.get('API_HOST')}/marketsummary/AreaLivre`,
                header: {
                    'X-UIKey': 'area-selection-summary-view'
                },
                data: stringifyGeoJSON(req)
            }).then(res => reducers.location(res, req), notifyError);
        },

        period () {
            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/marketsummary/GetMidSummaryFilter`,
                async: false
            }).then(reducers.period, notifyError);
        },

        detailedMarketSales (req) {
            req.startDate = environment.validate.date.start(req.startDate, 'YYYYMM');
            req.endDate = environment.validate.date.end(req.endDate, 'YYYYMM');

            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/marketsummary/GetMidSummarySalesDetails`,
                data: {
                    ids: req.id,
                    anoMesInicio: req.startDate,
                    anoMesFim: req.endDate,
                    idTipoLocalidade: req.type,
                    agrupamento: req.grouping,
                    tipoVenda: req.idSalesType,
                    idsCompanySize: req.idsCompanySize
                }
            }).then(reducers.marketShareSalesDetails, notifyError);
        },

        invasionIndicator (req) {
            req.startDate = environment.validate.date.start(req.startDate, 'YYYYMM');
            req.endDate = environment.validate.date.end(req.endDate, 'YYYYMM');

            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/marketsummary/GetMidSummaryInvasionIndicator`,
                data: {
                    ids: req.id,
                    initialDate: req.startDate,
                    finalDate: req.endDate,
                    idSalesType: req.idSalesType
                }
            }).then(reducers.invasionIndicator, notifyError);
        },

        detailedMarketShare (req) {
            req.startDate = environment.validate.date.start(req.startDate, 'YYYYMM');
            req.endDate = environment.validate.date.end(req.endDate, 'YYYYMM');

            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/marketsummary/GetMidSummaryDetalhado`,
                data: {
                    ids: req.id,
                    saleType: req.idSalesType && Number.isInteger(req.idSalesType) ? req.idSalesType : 3,
                    anoMesInicio: req.startDate,
                    anoMesFim: req.endDate,
                    idTipoLocalidade: req.type,
                    idsSegmento: req.segments,
                    idsCompanySize: req.idsCompanySize
                }
            }).then((res) => reducers.marketShare(res, req), notifyError);
        }
    };

    return {
        get
    };
})();

export default summary;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/summary/index.js